<div class="Txt-Withdraw-Coinbase">
  <div style="margin-top: 20px">
    <h2>{{ 'Balance' | t }} {{ this._UserHelper.customerUser?.Balance }}</h2>
  </div>

  <form class="example-form" [formGroup]="coinbaseWithdrawDatas">
    <div class="credit-input-container">
      <inputb3
        [extraClass]="'amountInput'"
        fPlaceholder="{{ 'Amount' | t }}"
        fInputType="number"
        fSuffixText="{{ this._UserHelper.customerUser.Symbol }}"
        formControlName="withdrawamount"></inputb3>
    </div>
  </form>
  <div class="confirm-button-container">
    <!-- <div class="alert-message" *ngIf="alertMessage">
      {{ alertMessageDesc }}
    </div> -->
    <ng-template #noAmount>
      <div class="btn colored register-button save-changes-button confirm-button opacity">
        <div class="btn-text">{{ 'Confirm' | t }}</div>
      </div>
    </ng-template>
    <div *ngIf="coinbaseWithdrawDatas.valid; else noAmount" class="btn colored register-button save-changes-button confirm-button" (click)="submitCoinbaseWithdrawData()">
      <div class="btn-text">{{ 'Confirm' | t }}</div>
    </div>
  </div>
</div>
